import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-564e6edb-bccd-465b-b954-9946a6e411f0-__Layer_1",
  "enable-background": "new 0 0 64 64",
  height: "48px",
  viewBox: "0 0 1024 1024",
  width: "48px",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M 1010.138 312.27 C 873.956 448.451 737.775 584.633 601.593 720.814 C 582.48 739.928 563.367 759.041 544.253 778.154 C 525.14 797.267 494.081 797.267 477.357 778.154 C 341.175 641.972 207.383 508.18 71.201 371.998 C 52.088 352.885 32.975 333.772 13.862 314.659 C -29.143 271.654 37.753 202.369 80.758 247.763 C 216.94 383.944 350.732 517.737 486.914 653.918 C 494.081 661.086 503.638 670.642 510.805 677.81 C 635.041 553.574 759.277 429.338 885.902 302.713 L 943.242 245.373 C 986.246 202.369 1053.142 269.265 1010.138 312.27 Z",
      style: {"transform-origin":"512px 512px"},
      transform: "matrix(0, 1, -1, 0, 0, 0)"
    }, null, -1)
  ]))]))
}
export default { render: render }